import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'

export type MiniStatTone = 'blue' | 'amber' | 'emerald' | 'orange' | 'purple' | 'rose' | 'slate' | 'teal'

interface MiniStatProps {
  label: string
  value: ReactNode
  tone: MiniStatTone
  context?: ReactNode
  href?: string
}

const toneClasses: Record<MiniStatTone, { border: string; bg: string; dot: string }> = {
  blue: { border: 'border-blue-200', bg: 'bg-blue-50/70', dot: 'bg-blue-500' },
  amber: { border: 'border-amber-200', bg: 'bg-amber-50/70', dot: 'bg-amber-500' },
  emerald: { border: 'border-emerald-200', bg: 'bg-emerald-50/70', dot: 'bg-emerald-500' },
  orange: { border: 'border-orange-200', bg: 'bg-orange-50/70', dot: 'bg-orange-500' },
  purple: { border: 'border-purple-200', bg: 'bg-purple-50/70', dot: 'bg-purple-500' },
  rose: { border: 'border-rose-200', bg: 'bg-rose-50/70', dot: 'bg-rose-500' },
  slate: { border: 'border-slate-200', bg: 'bg-slate-50', dot: 'bg-slate-400' },
  teal: { border: 'border-teal-200', bg: 'bg-teal-50/70', dot: 'bg-teal-500' },
}

export function MiniStat({ label, value, tone, context, href }: MiniStatProps) {
  const classes = toneClasses[tone] ?? toneClasses.slate
  const content = (
    <div className={`rounded-xl border p-4 transition hover:border-brand-300 hover:bg-white ${classes.border} ${classes.bg}`}>
      <div className="flex items-center gap-2 text-xs font-medium uppercase tracking-wide text-slate-500">
        <span className={`h-2 w-2 rounded-full ${classes.dot}`} />
        {label}
      </div>
      <div className="mt-2 text-2xl font-semibold text-slate-950">{value}</div>
      {context ? (
        <div className="mt-1 text-xs text-slate-600">{context}</div>
      ) : null}
    </div>
  )

  return href ? (
    <Link to={href} className="block">
      {content}
    </Link>
  ) : content
}
